import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useLoader } from "@/app/hooks/useLoader";
import { useRouter } from "@/app/hooks/useRouter";
import DataTable from "@/app/components/ui/Reusable/DataTable";
import SolidButton from "@/app/components/ui/Buttons/SolidButton";
import NoDataFoundComponent from "@/app/components/ui/NoRecordFound";
import { IConfigurationRolesAndPermissionListResponseData } from "@/api_framework/api_modals/Configuration";
import { useConfigurationRBACListAPI } from "@/app/hooks/api_hooks/configuration/useConfigurationRBACListAPI";
import { getRolesColumns } from "@/app/hooks/custom_hooks";

const ConfigurationRolesSetup = () => {
  const isRolesAndPermissionLoading = useLoader("isRolesAndPermissionListInProgress");
  const [rolesAndPermissions, setRolesAndPermissions] = useState<IConfigurationRolesAndPermissionListResponseData[]>(
    [],
  );
  const { getRouteKey } = useRouter();
  const navigate = useNavigate();
  const fetchUserRoleAndPermissions = useConfigurationRBACListAPI();
  const columns = getRolesColumns(navigate, getRouteKey);

  useEffect(() => {
    fetchUserRoleAndPermissions().then((list) => {
      setRolesAndPermissions(list);
    });
  }, []);

  return (
    <>
      <div className="px-5 py-3">
        <div className="sm:flex sm:items-center">
          <div className="sm:flex-auto">
            <h1 className="text-base font-semibold leading-6 text-gray-900">Roles and Permissions</h1>
            <p className="mt-2 text-sm text-gray-700">
              A list of all the roles and permissions assigned to different users of VMS.
            </p>
          </div>
          <div className="mt-4 sm:ml-16 sm:mt-0 sm:flex-none">
            <SolidButton asLink href={getRouteKey("ROLES_PERMISSION_ONBOARD", "url")} size="XL">
              Add Role & Permission
            </SolidButton>
          </div>
        </div>
        {isRolesAndPermissionLoading ? (
          <div className="mt-3"></div>
        ) : rolesAndPermissions?.length > 0 ? (
          <div>
            <DataTable data={rolesAndPermissions || []} columns={columns} maxHeight="650px" />
          </div>
        ) : (
          <NoDataFoundComponent message="No Roles And Permissions Available." />
        )}
      </div>
    </>
  );
};

export default ConfigurationRolesSetup;
